/**
 * Count formatting for stat tiles: compactCount folds thousands into "5K"
 * / "1.2M" (a 28px display number has no room for "12,345"); exactCount is
 * the grouped full figure for the tooltip beside it.
 */
export function compactCount(n: number, locale?: string): string {
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat(locale, { notation: "compact", maximumFractionDigits: 1 }).format(n);
}

export function exactCount(n: number, locale?: string): string {
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat(locale).format(n);
}

/**
 * The profile's hours-watched figure beside the counts: "0 h" for nothing
 * (or under a minute), "42 min" under an hour, "4.6 h" / "12 h" up to a
 * hundred hours, then whole hours folded like a count ("128 h", "1.2K h").
 * The exact form for its tooltip is formatRuntime ("4 h 36 min").
 */
export function formatWatchedTime(ms: number, locale?: string): string {
  if (!Number.isFinite(ms)) return "—";
  if (ms < 60_000) return "0 h";
  if (ms < 3_600_000) return `${Math.floor(ms / 60_000)} min`;
  const hours = ms / 3_600_000;
  if (hours < 100) {
    return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(hours)} h`;
  }
  return `${compactCount(Math.round(hours), locale)} h`;
}
